import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import Card from '../../components/Card/Card';
import ExamForm from './ExamForm';
import Button from "../../components/Button/Button";
import { useParams, useNavigate } from 'react-router-dom';
import './Exam.css';
import Loader from '../../components/Loader/Loader';
import { enqueueSnackbar } from 'notistack';
import { getClassWiseSubjects } from '../../services/SubjectServices';
import { getProgramWiseExamList, getExamById, updateExam, createExam } from '../../services/ExamService';
import { getClassWiseStudentList } from '../../services/StudentService';
import { getStudentSubjectMappingList } from '../../services/StudentSubjectMappingService';
import { getScoreSchemeByEvaluationType } from '../../services/ScoreSchemeService';

const ExamManage = () => {
  const params = useParams();
  const navigate = useNavigate();
  const [studentSubjectWise, setSetStudentSubjectWise] = useState(false);
  const [program_id, setProgramId] = useState("");
  const [gradeSchemeID, setGradeSchemeID] = useState("");
  const [grade_scheme_type, setGradeSchemeType] = useState("");
  const [student_ids, setStudentIds] = useState([]);
  const [isMounted] = useState(true);
  const [scoreSchemesData, setScoreSchemesData] = useState([]);
  const session_id = localStorage.getItem("session_id");
  const [state, setState] = useState({
    name: '', start: '', end: '', term: '', is_active: 1,
    description: '', student_loader: false,
    loader: false, error: [], grade_method: "", startDate: '',
    endDate: '', sessionData: [], programData: [], subjectData: [], selectedSubjects: [],
    examList: [], evaluationTypeData: [], scoreSchemesData: [], gradingMethodsData: [],
    student_ids: [], is_traits: false, maxScore: "",
    traits: [{ trait_id: "", trait_grade_scheme_type: "" }],
    studentList: [], attempts: "NO", total_attempts: "", participants: [],
    freezed: false,
  });
  const path = window.location.pathname;

  const getSubject = async (programId) => {
    try {
      const res = await getClassWiseSubjects(programId);
      const subjectData = res.data.data;
      setState((prevState) => ({ ...prevState, subjectData }));
    } catch (error) {
    }
  };

  const fetchScoreSchemesByEvalation = async (id) => {

    try {
      const response = await getScoreSchemeByEvaluationType(id);
      if (response.status === 200) {
        const scoreSchemesData = response.data.data;
        setScoreSchemesData(scoreSchemesData);
      }
    }
    catch (error) {
      console.error(error);
    }
  };

  const getStudentListSubjectWise = async (program_id, subject_id) => {
    setState((prevState) => ({ ...prevState, student_loader: true, studentList: [] }));
    try {
      const response = await getStudentSubjectMappingList(session_id, program_id, subject_id);
      if (response.status === 200) {
        setState((prevState) => ({ ...prevState, student_loader: false }));
        const studentList = response.data.data;
        setState((prevState) => ({ ...prevState, studentList }));
      }
    } catch (error) {
      setState((prevState) => ({ ...prevState, loader: false, student_loader: false }));
      console.error(error);
    }
    finally {
      setState((prevState) => ({ ...prevState, student_loader: false }));
    }
  };

  const getStudentList = async (program_id, subject_id) => {
    setState((prevState) => ({ ...prevState, student_loader: true, studentList: [] }));
    try {
      let response = await getClassWiseStudentList(program_id);
      if (response.status === 200) {
        setState((prevState) => ({ ...prevState, student_loader: false }));
        const studentList = response.data.data;
        setState((prevState) => ({ ...prevState, studentList }));
      }
    } catch (error) {
      setState((prevState) => ({ ...prevState, loader: false, student_loader: false }));
      console.error(error);
    }
    finally {
      setState((prevState) => ({ ...prevState, student_loader: false }));
    }
  };

  const changeStudentSubjectWise = (event) => {
    const isConfirmed = window.confirm("Are you sure you want to change the student setting,selected student will be disappear?");
    if (!isConfirmed) {
      return; // Exit if the user cancels
    }
    setState((prevState) => ({ ...prevState, student_loader: true, studentList: [] }));
    setStudentIds([]);
    if (event.target.value === "true") {
      getStudentListSubjectWise(program_id, state.subject_id);
      setSetStudentSubjectWise(true);
    }
    else {
      setSetStudentSubjectWise(false);
      getStudentList(program_id, 0);
    }
  }

  const getExamList = async (program_id) => {
    setState((prevState) => ({ ...prevState, student_loader: true }));
    try {
      const response = await getProgramWiseExamList(program_id);
      if (response.status === 200) {
        setState((prevState) => ({ ...prevState, student_loader: false }));
        const examList = response.data.data;
        setState((prevState) => ({ ...prevState, examList }));
      }
    } catch (error) {
      setState((prevState) => ({ ...prevState, loader: false, student_loader: false }));
      console.error(error);
    }
  };

  const getUniqueEvent = useCallback(async () => {
    setState((prevState) => ({ ...prevState, loader: true }));
    try {
      const response = await getExamById(params.id, session_id);
      if (response.status === 200) {
        const data = response.data.data;
        const {
          id, term, description, start,
          end, program, subject, evaluation_type,
          grade_scheme, attempts, total_attempts,
          is_traits, traits, max_score, participants,
        } = data;
        let name = data.name.id;
        getExamList(program.id);
        getSubject(program.id);
        setProgramId(program.id);
        setGradeSchemeID(grade_scheme.id);
        setGradeSchemeType(grade_scheme.type);
        setState((prevState) => ({
          ...prevState, loader: false,
          id, name, term, description, start,
          end, subject_id: subject.id, evaluation_type_id: evaluation_type.id,
          attempts, total_attempts, is_traits,
          traits: traits.map((item) => ({
            trait_grade_scheme_type: item.grade_scheme.type,
            label: item.subject_trait.name,
            value: item.subject_trait.id,
            trait_id: item.subject_trait.id,
            grade_scheme_id: grade_scheme.id,
          })),
          maxScore: max_score,
          participants: participants.map((item) => item.id),
        }));
        setStudentIds(participants.map((item) => item.id.toString()));
        getStudentList(program.id, 0);
        fetchScoreSchemesByEvalation(evaluation_type.id);
      }
    } catch (error) {
      console.error(error);
    }
    finally {
      setState((prevState) => ({ ...prevState, loader: false }));
    }
  }, [params.id, session_id]);

  useEffect(() => {
    if (params.id) {
      getUniqueEvent();
    }
    const fetchData = async () => {
      try {
        const org_id = localStorage.getItem("organization_id");
        if (!org_id) {
          enqueueSnackbar("Please select any organization", { variant: 'error' });
        }
        const gradingMethodsResponse = await axios.get(`/grade/methods`);
        const gradingMethodsData = gradingMethodsResponse.data.data;
        setState((prevState) => ({ ...prevState, gradingMethodsData, loading: false }));
      } catch (error) {
        if (error.name === 'AbortError') {
        } else {
          console.error('Error:', error);
        }
      }
    };
    fetchData();
  }, [getUniqueEvent, params.id]);

  const addNewRow = () => {
    if (isMounted)
      setState((prevState) => ({
        ...prevState,
        traits: [...prevState.traits, {}],
      }));
  };

  const clickOnDelete = (e, record) => {
    e.preventDefault();
    e.stopPropagation();
    if (isMounted)
      setState((prevState) => ({
        ...prevState,
        traits: prevState.traits.filter((r) => r !== record),
      }));
  };

  const handleChangeTraits = (event, index) => {
    const { name, value, label } = event.target;
    const updatedTraits = [...state.traits];
    updatedTraits[index][name] = value;
    updatedTraits[index]["label"] = label;
    updatedTraits[index]["grade_scheme_id"] = gradeSchemeID
    updatedTraits[index]["trait_grade_scheme_type"] = grade_scheme_type;
    if (isMounted)
      setState({ ...state, traits: updatedTraits });
  };

  const handleChangeTraitsScheme = (event, index) => {
    const { name, value } = event.target;
    const updatedTraits = [...state.traits];
    if (name === "grade_scheme_id") {
      scoreSchemesData.forEach((item) => {
        if (Number(item.id) === Number(value)) {
          updatedTraits[index]["grade_scheme_id"] = item.id;
          updatedTraits[index]["trait_grade_scheme_type"] = item.type;
        }
      });
    } else {
      updatedTraits[index][name] = value;
    }
    setState({ ...state, traits: updatedTraits });
  };

  const handleInputChange = (event) => {
    const { value, checked } = event.target;
    const student_id = value;
    if (checked) {
      setStudentIds([...student_ids, student_id]);
    } else {
      const updatedStudentIds = student_ids.filter((id) => id !== student_id);
      setStudentIds(updatedStudentIds);
    }
  };

  const selectAllStudent = (event) => {
    const student_ids = [];
    if (event.target.checked) {
      state.studentList.forEach((student) => {
        const id = student.id.toString();
        student_ids.push(id);
      });
    }
    setStudentIds(student_ids);
  };

  const handleChange = (event) => {
    const { name, value, checked } = event.target;
    if (name === "is_traits") {
      setState({ ...state, is_traits: checked });
    } else if (name === "gradeSchemeID") {
      const selectedItem = scoreSchemesData && scoreSchemesData.find((item) => Number(item.id) === Number(value));
      setGradeSchemeID(value);
      if (selectedItem) {
        setGradeSchemeType(selectedItem.type);
      }
    }
    else if (name === "evaluation_type_id") {
      setState({ ...state, evaluation_type_id: value });
      fetchScoreSchemesByEvalation(value);
    }
    else if (name === "program_id") {
      setProgramId(value);
      getStudentList(value, 0);
      getExamList(value);
      getSubject(value);
      setStudentIds([]);
    }
    else if (name === "subject_id") {
      setState({ ...state, subject_id: value });
      if (studentSubjectWise)
        getStudentListSubjectWise(program_id, value);
    }
    else if (name === "is_active") {
      if (checked)
        setState({ ...state, is_active: 1 });
      else
        setState({ ...state, is_active: 0 });
    }
    else {
      setState(() => ({ ...state, [name]: value }));
    }
  };

  const onSubjectSelect = (event) => {
    setState((prevState) => ({
      ...prevState,
      subject_ids: event,
      selectedSubjects: event,
    }));
    if (studentSubjectWise)
      getStudentList(program_id, event[0].id);
  };

  const onSubjectRemove = (event) => {
    setState((prevState) => ({
      ...prevState,
      subject_ids: event,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const pathname = window.location.pathname;
    const clone = pathname.includes('clone');
    if (isMounted)
      setState((prevState) => ({
        ...prevState, loader: true, attempts: "NO", total_attempts: ""
      }));
    const grade_scheme_id = gradeSchemeID;
    const max_score = state.maxScore;
    let traits;

    if (!state.is_traits) {
      traits = [];
    } else {
      traits = state.traits.map((item) => {
        return {
          trait_id: item.trait_id,
          grade_scheme_id: item.grade_scheme_id,
        };
      });
    }

    const {
      name, term, start, end, evaluation_type_id,
      attempts, total_attempts, grade_method, description,
      is_traits, is_active,
    } = state;

    const data = {
      name, term, session_id, start, end,
      program_id, evaluation_type_id, grade_scheme_id,
      attempts, total_attempts, grade_method, description,
      max_score, student_ids, is_traits, traits, is_active,
    };

    try {
      if (params.id) {
        data.subject_id = state.subject_id;

        let response;
        if (clone) {
          delete data.id;
          data.subject_ids = [data.subject_id];
          response = await createExam({ data });
        }
        else {
          response = await updateExam(params.id, { data });
        }

        if (response.status === 200) {
          let msg = response.data.message.success;
          enqueueSnackbar(msg, { variant: 'success' });
          navigate("/exam/list");
        }
        else {
          enqueueSnackbar(response.data.message.error, { variant: 'error' });
        }

        if (isMounted)
          setState((prevState) => ({ ...prevState, loader: false }));
      } else {
        data.subject_ids = state.subject_ids && state.subject_ids.map((item) => item.id);
        const response = await createExam({ data });
        if (isMounted)
          setState((prevState) => ({ ...prevState, loader: false }));
        if (response.status === 200) {
          enqueueSnackbar(response.data.message.success, { variant: 'success' });
          if (!state.freezed) {
            navigate("/exam/list");
          }
        }
      }
    } catch (error) {
      setState((prevState) => ({ ...prevState, loader: false }));
      console.error(error);
      enqueueSnackbar("Something went wrong!", { variant: 'error' });
    }
    finally {
      setState((prevState) => ({ ...prevState, loader: false }));
    }
  };

  const back = () => {
    navigate("/exam/list");
  };

  return (
    <Card
      componentName={state.id ? path.includes("clone") ? "Clone Exam" : "Update Exam" : "Add Exam"}
      back={back}
      freezed={<Button variant={state.freezed ? "primary" : "secondary"}
        onClick={() => setState((prevState) =>
          ({ ...prevState, freezed: !prevState.freezed }))}>
        {!state.freezed ? "Freeze" : "Unfreeze"}
      </Button>}
    >
      {state.loader ?
        <Loader /> :
        <ExamForm
          submitHandler={handleSubmit}
          changeHandler={handleChange}
          changeTraitHandler={handleChangeTraits}
          handleChangeTraitsScheme={handleChangeTraitsScheme}
          selectAllStudent={selectAllStudent}
          inputChangeHandler={handleInputChange}
          addRow={addNewRow}
          clickOnDelete={clickOnDelete}
          data={state}
          program_id={program_id}
          scoreSchemesData={scoreSchemesData}
          gradeSchemeID={gradeSchemeID}
          grade_scheme_type={grade_scheme_type}
          student_ids={student_ids}
          subjectData={state.subjectData}
          onSubjectSelect={onSubjectSelect}
          onSubjectRemove={onSubjectRemove}
          selectedSubjects={state.selectedSubjects}
          studentSubjectWise={studentSubjectWise}
          changeStudentSubjectWise={changeStudentSubjectWise}
        />}
    </Card>
  );
};
export default ExamManage;
